// extracted by mini-css-extract-plugin
export default {"recos":"Zha-z","productCardOverride":"_ha-z","rowHasBadge":"aia-z"};